import Vue from 'vue'
import {NOTIFICA_ERRORE, NOTIFICA_SUCCESSO} from '../../costanti'
// moment

export default {
    namespaced: true,
    state: {
        interventiEseguiti: null
    },
    mutations: {
        SET_INTERVENTI_ESEGUITI: (state: any, interventiEseguiti: any) => {
            state.interventiEseguiti = interventiEseguiti
        },
        ORDER_BY_ID: (state: any) => {
            state.interventiEseguiti = state.interventiEseguiti.sort((a, b) => a.id - b.id)
        },
        ORDER_BY_RILEVAMENTO_ID: (state: any) => {
            state.interventiEseguiti = state.interventiEseguiti.sort((a, b) => a.rilevamento_id - b.rilevamento_id)
        },
        ORDER_BY_DATA_INTERVENTO: (state: any) => {
            state.interventiEseguiti = state.interventiEseguiti.sort((a, b) =>
                a.data_intervento.localeCompare(b.data_intervento))
        },
        ORDER_BY_DATA_PROSSIMO_INTERVENTO: (state: any) => {
            state.interventiEseguiti = state.interventiEseguiti.sort((a, b) =>
                (a.data_prossimo_intervento || '3000-01-01').localeCompare(b.data_prossimo_intervento || '3000-01-01'))
        }
    },
    actions: {
        pullInterventiEseguiti({commit}: any) {
            // troviamo gli interventi eseguiti
            Vue.axios.get(`/api_mapplants/interventi_eseguiti.json`).then(
                (response: any) => {
                    const interventiEseguiti = response.data
                    commit('SET_INTERVENTI_ESEGUITI', interventiEseguiti)
                },
                (err: any) => {
                    console.error(err)
                }
            )
        },
        async modificaRilevamento({commit, dispatch, rootState}: any, {id, rilevamento}: any) {
            // aggiorniamo il rilevamento
            try {
                const response = await Vue.axios.patch(`/api_mapplants/rilevamenti/${id}/`, rilevamento)
                dispatch('showNotification', {
                    name: NOTIFICA_SUCCESSO,
                    title: 'Rilevamento modificato'
                })
            } catch (err) {
                console.error(err)
                dispatch('showNotification', {
                    name: NOTIFICA_ERRORE,
                    title: `Errore durante la modifica`,
                    content: err.message
                })
            }
        },
        async eliminaRilevamento({commit, dispatch, rootState}: any, id: number) {
            // eliminiamo il rilevamento
            try {
                const response = await Vue.axios.delete(`/api_mapplants/rilevamenti/${id}/`)
                dispatch('showNotification', {
                    name: NOTIFICA_SUCCESSO,
                    title: 'Rilevamento elimnato'
                })
                // chiudiamo il modal
                dispatch('showModal', null)
                // carichiamo i nuovi dati
                dispatch('mapplantsMappa/caricaRilevamenti', {}, {root: true})
            } catch (err) {
                console.error(err)
                dispatch('showNotification', {
                    name: NOTIFICA_ERRORE,
                    title: `Errore durante l'eliminazione`,
                    content: err.message
                })
            }
        }
    }
}
